import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";

const FooterCopyright = ({
  footerLogo,
  siteName,
  footerText,
  copyrightText,
  spaceBottomClass,
  colorClass
}) => {
  return (
    <div className={clsx("copyright", spaceBottomClass, colorClass)}>
      <div className="footer-logo">
        <Link
          to={process.env.PUBLIC_URL + "/"}
          className="inline-flex items-center gap-2"
        >
        </Link>
      </div>

      {footerText && (
        <p className="text-sm text-gray-500 mb-2">{footerText}</p>
      )}

      <p className="text-xs text-gray-400">
        {copyrightText || "© All Rights Reserved"}
      </p>
    </div>
  );
};

FooterCopyright.propTypes = {
  footerLogo: PropTypes.string,
  siteName: PropTypes.string,
  footerText: PropTypes.string,
  copyrightText: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string
};

export default FooterCopyright;
